import React from "react";
import { Brain } from "lucide-react";

const LoadingOverlay = ({ message, darkMode }) => {
  const theme = {
    card: darkMode ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200",
    text: darkMode ? "text-gray-100" : "text-gray-900",
    textSecondary: darkMode ? "text-gray-400" : "text-gray-600",
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 backdrop-blur-sm">
      <div
        className={`${theme.card} rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl`}
      >
        <div className="text-center">
          <div className="relative mb-6">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200 border-t-blue-600 mx-auto"></div>
            <Brain className="h-8 w-8 text-blue-600 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
          </div>
          <p className={`${theme.text} font-medium text-lg mb-2`}>{message}</p>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-1000 animate-pulse"
              style={{ width: "75%" }}
            ></div>
          </div>
          <p className={`text-sm ${theme.textSecondary}`}>Please wait...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;